import {
	BaseApiService,
	BaseDeleteDto,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto
} from "@remar/shared/dist/api/baseApiService";
import { Lesson } from "@remar/shared/dist/models";

import { URLS } from "../services.constants";

export class DifficultyLevelTiersService extends BaseApiService<
	//change this lesson
	Lesson,
	Record<string, unknown>,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto<Record<string, unknown>>,
	BaseDeleteDto
> {
	constructor(baseUrl: string) {
		super(baseUrl);
	}
}

export const difficultyLevelTiersService = new DifficultyLevelTiersService(URLS.QUESTION_DIFFICULTY_LEVELS_TIERS);
